import style from "./style.module.css";

interface TeamRoleInfoMessageProps {
  className: string;
}

const TeamRoleInfoMessage = ({ className }: TeamRoleInfoMessageProps) => {
  return (
    <div className={`${style.teamRoleContent} ${className}`}>
      <div>
        Roles in Easil are cumulative, meaning that more than one role can be
        assigned to each team member.
      </div>
      <a
        href="https://support.easil.com/updating-roles-and-permissions-of-team-members/"
        rel="noopener noreferrer"
        target="_blank"
        className={style.learnMore}
      >
        Learn more.
      </a>
    </div>
  );
};

export default TeamRoleInfoMessage;
